(() => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuButton && mobileMenu) {
    const closeMenu = () => {
      mobileMenu.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('menu-open');
    };

    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      mobileMenu.hidden = isOpen;
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      menuButton.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
      document.body.classList.toggle('menu-open', !isOpen);
    });

    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
  }

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const viewport = gallery.querySelector('[data-gallery-viewport]');
    const mediaItems = Array.from(gallery.querySelectorAll('[data-gallery-media]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const previousButton = gallery.querySelector('[data-gallery-previous]');
    const nextButton = gallery.querySelector('[data-gallery-next]');
    let activeIndex = Math.max(0, mediaItems.findIndex((item) => item.classList.contains('is-active')));
    let touchStartX = 0;

    const pauseInactiveMedia = (item) => {
      item.querySelectorAll('video').forEach((video) => video.pause());
      item.querySelectorAll('model-viewer').forEach((model) => {
        if (typeof model.pause === 'function') model.pause();
      });
    };

    const activateMedia = (index, moveFocus = false) => {
      if (!mediaItems.length) return;
      activeIndex = (index + mediaItems.length) % mediaItems.length;

      mediaItems.forEach((item, itemIndex) => {
        const isActive = itemIndex === activeIndex;
        item.hidden = !isActive;
        item.classList.toggle('is-active', isActive);
        if (!isActive) pauseInactiveMedia(item);
      });

      thumbnails.forEach((thumbnail) => {
        const isActive = thumbnail.dataset.mediaId === mediaItems[activeIndex].dataset.mediaId;
        if (isActive) {
          thumbnail.setAttribute('aria-current', 'true');
          thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          if (moveFocus) thumbnail.focus();
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });
    };

    const activateMediaById = (mediaId) => {
      if (!mediaId) return;
      const index = mediaItems.findIndex((item) => item.dataset.mediaId === mediaId);
      if (index >= 0) activateMedia(index);
    };

    thumbnails.forEach((button) => {
      button.addEventListener('click', () => activateMediaById(button.dataset.mediaId));
    });

    previousButton?.addEventListener('click', () => activateMedia(activeIndex - 1, true));
    nextButton?.addEventListener('click', () => activateMedia(activeIndex + 1, true));

    viewport?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });

    viewport?.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX || 0;
      const distance = touchEndX - touchStartX;
      if (Math.abs(distance) < 45) return;
      activateMedia(distance > 0 ? activeIndex - 1 : activeIndex + 1);
    }, { passive: true });

    gallery.activateMediaById = activateMediaById;
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const addButton = form.querySelector('[data-add-button]');
    const price = form.closest('[data-product-section]')?.querySelector('[data-product-price]');
    if (!variantSelect || !addButton) return;

    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';
      addButton.disabled = !available;
      addButton.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const gallery = form.closest('[data-product-section]')?.querySelector('[data-gallery]');
      gallery?.activateMediaById?.(option.dataset.mediaId);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });
})();